export default "__VITE_ASSET__BZmuId8A__"